function stringToColor(stringContent) {
    let hash = 0;
    let i;
    for (i = 0; i < stringContent.length; i += 1) {
        hash = stringContent.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    return `${color}30`;
}
function getInitialsFromText(text) {
    const initials = text.split(" ").map((word) => word.charAt(0));
    return initials.join("").substr(0, 2);
}
export function getUserAvatarProps(name, tokens, textColor) {
    const defaultTextColor = tokens.semantic.color.text.body.value;
    return {
        sx: {
            bgcolor: stringToColor(name),
            color: textColor || defaultTextColor,
        },
        children: getInitialsFromText(name),
    };
}
//# sourceMappingURL=userLookup.js.map